// composables/useEventBus.ts
import mitt from "mitt";

type ApplicationEvents = {
  "toolbar:export-table-pdf"?: null;
  "toolbar:export-table-xlsx"?: null;
  "toolbar:print-table"?: null;
  "filtro:print-table"?: null;
  "filtro:print-dashboard"?: null;
  "filtro:export-table-xlsx"?: null;
  "toolbar:config-table-cols"?: null;
  "toolbar:config-report"?: null;
  "toolbar:tutorial-modal"?: null;
  "modal:show"?: null;
  "modalLogin:show": boolean;
  "dashboard:tabs"?: null;
  "dashboard-box-removed"?: null;
  "report:update-available-reports": string;
  "report:update-report"?: null;
  "reload:report-table"?: null;
  "update:modelValue"?: null;
  "custom-report:update-aggregator": string | number | null;
  "report:data-restored"?: object;
  "report:search-completed"?: object;
  "report:type-changed"?: object;
  "dashboard:save-data"?: null;
  "dashboard:copy"?: null;
  "dashboard:create-box-chart": ChartType;
  "navbarEditor: openFile"?: null;
  "navbarEditor: openReportModal": boolean;
  "navbarEditor: openSaveModal": boolean;
  "dashboard:viewmode"?: null;
  "dashboard:currentTab"?: number;
  "toolbar:modal-column-table": boolean;
  "dashboard:viewmodeOff"?: null;
  "dashboard:tutorial-modal-chart"?: null;
  "dashboard:search-data"?: null;
  "dashboard:modal-background"?: null;
  "dashboard-add"?: null;
  "update:Type"?: string;
  "navbar-editor: open-save-modal"?: boolean;
  "table:print-head-and-foot"?: null;
  "ReportFilters: filters"?: null;
  "chart:addNewDataset"?: null;
  "printtabs:print-table"?: null;
  "report:change-tab"?: object;
  "notaFiscal:emissor"?: null;
  "printheaderandfooter:print-table"?: null;
  "report-editor:update-selected-object"?: null;
  "report-editor-sql:comment-selection"?: null;
  "report-editor-sql:uncomment-selection"?: null;
  "report-editor-sql:highlight"?: null;
  "report-editor-sql:save-SQL-code"?: null;
  "report-editor-sql:add-cols"?: null;
  "navbar-sql:sql-select-option": string;
  "navbar-sql:execute-sql"?: null;
  "navbar-sql:load-SQL-file"?: null;
  "navbar-sql:add-cols"?: null;
  "toolbar:open-tutorial-mod"?: boolean;
  "imprimir:totem-senha"?: null;
  "totem-senha:config-modal": boolean;
  playerReady: boolean;
  playerPlaying: boolean;
  "login:success": string;
  "telao:seek": number;
  "telao:save-position": boolean;
  "telao:mute": boolean;
  playerEnded: boolean;
  playerError: boolean;
  streamPlayerMounted: boolean;
  "telao:select-telao"?: null;
  "telao:set-preview"?: any;
  "telao:config-modal": boolean;
  "telao:insert-link": boolean;
  "totem-senha:button-senha"?: null;
  "totem-senha:print": boolean;
  "modalPinpad:show": boolean;
  "videoEnded:video": boolean;
  "modalSQL:show": boolean;
  "videoLocalAutoPlay:video": boolean;
  "videoLocalMuted:video": boolean;
  "telao:video": boolean;
  loadReport?: null;

  // 🆕 NOVOS EVENTOS RELACIONADOS AO PIN
  "pin:authenticated": boolean;
  "pin:failed": string;
  "pin:logout"?: null;
  "pin:token-expired"?: null;
  "pin:modal-closed"?: null;
};

const emitter = mitt<ApplicationEvents>();

export const useEvent = emitter.emit;
export const useListen = emitter.on;
export const useEventOff = emitter.off;

// 🆕 HELPER FUNCTIONS PARA EVENTOS DE PIN
export const usePinEvents = () => {
  /**
   * Emite evento de autenticação bem-sucedida
   */
  const emitPinAuthenticated = () => {
    useEvent("pin:authenticated", true);
    console.log("[PinEvents] Evento pin:authenticated emitido");
  };

  /**
   * Emite evento de falha na autenticação
   */
  const emitPinFailed = (error: string) => {
    useEvent("pin:failed", error);
    console.log("[PinEvents] Evento pin:failed emitido:", error);
  };

  /**
   * Emite evento de logout/token expirado
   */
  const emitPinLogout = () => {
    useEvent("pin:logout");
    console.log("[PinEvents] Evento pin:logout emitido");
  };

  /**
   * Emite evento de token expirado
   */
  const emitPinTokenExpired = () => {
    useEvent("pin:token-expired");
    console.log("[PinEvents] Evento pin:token-expired emitido");
  };

  /**
   * Emite evento de modal fechado
   */
  const emitPinModalClosed = () => {
    useEvent("pin:modal-closed");
    console.log("[PinEvents] Evento pin:modal-closed emitido");
  };

  /**
   * Escutar evento de autenticação
   */
  const onPinAuthenticated = (callback: (success: boolean) => void) => {
    useListen("pin:authenticated", callback);
    return () => useEventOff("pin:authenticated", callback);
  };

  /**
   * Escutar evento de falha
   */
  const onPinFailed = (callback: (error: string) => void) => {
    useListen("pin:failed", callback);
    return () => useEventOff("pin:failed", callback);
  };

  /**
   * Escutar evento de logout
   */
  const onPinLogout = (callback: () => void) => {
    useListen("pin:logout", callback);
    return () => useEventOff("pin:logout", callback);
  };

  /**
   * Escutar evento de token expirado
   */
  const onPinTokenExpired = (callback: () => void) => {
    useListen("pin:token-expired", callback);
    return () => useEventOff("pin:token-expired", callback);
  };

  return {
    // Emitters
    emitPinAuthenticated,
    emitPinFailed,
    emitPinLogout,
    emitPinTokenExpired,
    emitPinModalClosed,

    // Listeners
    onPinAuthenticated,
    onPinFailed,
    onPinLogout,
    onPinTokenExpired,
  };
};
